import ProfilingInputCN from "./ProfilingInputCN";
import ProfilingResultCN from "./ProfilingResultCN";
import { useState, useCallback } from "react";
import { ProfilingAI } from "../../../lib/profilingApi";

export default function ProfilingPageCN() {
  const [text, setText] = useState("");
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // 부가 기능(6개)
  const [featureLoading, setFeatureLoading] = useState(false);
  const [featureError, setFeatureError] = useState("");
  const [activeFeature, setActiveFeature] = useState("");
  const [featureHtml, setFeatureHtml] = useState({
    mealPlan: "",
    qa: "",
    lifestyle: "",
    exercisePlan: "",
    meditationScript: "",
    snackAlternative: "",
  });

  const onSubmit = useCallback(async () => {
    if (!text.trim()) {
      alert("请输入患者问诊数据。");
      return;
    }
    setLoading(true);
    setError("");
    setAnswer("");

    // 부가기능 영역 초기화
    setActiveFeature("");
    setFeatureError("");
    setFeatureHtml({
      mealPlan: "",
      qa: "",
      lifestyle: "",
      exercisePlan: "",
      meditationScript: "",
      snackAlternative: "",
    });

    try {
      const res = await ProfilingAI.report({ intakeData: text, lang: "zh-CN" });
      setAnswer(res.html); // 섹션별 <div> HTML
    } catch (e) {
      setError(e?.message || "生成失败");
    } finally {
      setLoading(false);
    }
  }, [text]);

  const runFeature = useCallback(
    async (type) => {
      if (!answer) return; // 프로파일링 생성 전에는 호출 못 하도록 방어
      setActiveFeature(type);
      setFeatureLoading(true);
      setFeatureError("");

      try {
        const res = await ProfilingAI.feature({ type, intakeData: text, lang: "zh-CN" });
        setFeatureHtml((prev) => ({ ...prev, [type]: res.html }));
      } catch (e) {
        setFeatureError(e?.message || "生成失败");
      } finally {
        setFeatureLoading(false);
      }
    },
    [answer, text]
  );

  const onCopy = useCallback(async () => {
    if (!answer) return;
    try {
      const txt = new DOMParser().parseFromString(answer, "text/html").body.textContent || "";
      await navigator.clipboard.writeText(txt);
      alert("已复制到剪贴板。");
    } catch {
      const el = document.createElement("textarea");
      el.value = new DOMParser().parseFromString(answer, "text/html").body.textContent || "";
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      alert("已复制到剪贴板。");
    }
  }, [answer]);

  const showFeatures = !!answer && !loading && !error;

  return (
    <section>
      <div id="content_title">
        <h2>AI 初诊画像分析</h2>
        <p>从患者的首次咨询开始，AI 介入并生成深度分析画像。通过此方式，咨询主管能够以专家级洞察力开启与每位患者的首次沟通。</p>
      </div>

      <div className="content">
        <div>
          <ProfilingInputCN value={text} onChange={setText} onSubmit={onSubmit} loading={loading} />

          <ProfilingResultCN answer={answer} error={error} loading={loading} onCopy={onCopy} />

          {showFeatures && (
            <>
              <div className="profiling-feature-toolbar">
                <button onClick={() => runFeature("mealPlan")} disabled={featureLoading}>
                  一日定制食谱
                </button>
                <button onClick={() => runFeature("qa")} disabled={featureLoading}>
                  第一次商谈 Q&A
                </button>
                <button onClick={() => runFeature("lifestyle")} disabled={featureLoading}>
                  生活习惯改善案
                </button>
                <button onClick={() => runFeature("exercisePlan")} disabled={featureLoading}>
                  日间锻炼计划
                </button>
                <button onClick={() => runFeature("meditationScript")} disabled={featureLoading}>
                  冥想脚本
                </button>
                <button onClick={() => runFeature("snackAlternative")} disabled={featureLoading}>
                  健康夜宵对策
                </button>
              </div>

              {featureLoading && <p>创建中… 请稍等。</p>}
              {featureError && <p className="error">{featureError}</p>}

              <div className="profiling-feature-results">
                {activeFeature === "mealPlan" && featureHtml.mealPlan && <div className="feature-block feature-mealPlan" dangerouslySetInnerHTML={{ __html: featureHtml.mealPlan }} />}
                {activeFeature === "qa" && featureHtml.qa && <div className="feature-block feature-qa" dangerouslySetInnerHTML={{ __html: featureHtml.qa }} />}
                {activeFeature === "lifestyle" && featureHtml.lifestyle && <div className="feature-block feature-lifestyle" dangerouslySetInnerHTML={{ __html: featureHtml.lifestyle }} />}
                {activeFeature === "exercisePlan" && featureHtml.exercisePlan && <div className="feature-block feature-exercisePlan" dangerouslySetInnerHTML={{ __html: featureHtml.exercisePlan }} />}
                {activeFeature === "meditationScript" && featureHtml.meditationScript && <div className="feature-block feature-meditationScript" dangerouslySetInnerHTML={{ __html: featureHtml.meditationScript }} />}
                {activeFeature === "snackAlternative" && featureHtml.snackAlternative && <div className="feature-block feature-snackAlternative" dangerouslySetInnerHTML={{ __html: featureHtml.snackAlternative }} />}
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
